import { FilterState } from './filterSlice';

export default function buildQueryString(filter: FilterState) {
  const projects = filter.productLines.map((x) => `'${x}'`).join(',');
  let queryString = `SELECT [Id] from WorkItems WHERE [System.TeamProject] IN (${projects}) AND [Custom.Changelog] = 'True' AND [System.State] = 'Closed' `;
  for (let i = 0; i < filter.conditions.length; i++) {
    queryString += `AND ${filter.conditions[i]} `;
  }
  if (!(filter.workItemType.bug && filter.workItemType.userStory)) {
    if (filter.workItemType.bug) {
      queryString += 'AND [System.WorkItemType] = "Bug" ';
    }
    if (filter.workItemType.userStory) {
      queryString += 'AND [System.WorkItemType] = "User Story" ';
    }
  }
  if (filter.dateRange.from !== -1) {
    const date = new Date(filter.dateRange.from);
    queryString += `AND [Microsoft.VSTS.Common.ClosedDate] >= '${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}T00:00Z' `;
  }
  if (filter.dateRange.to !== -1) {
    const date = new Date(filter.dateRange.to);
    queryString += `AND [Microsoft.VSTS.Common.ClosedDate] <= '${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}T00:00Z' `;
  }
  if (filter.organizationId > -1) {
    if (filter.organizationId === 0) {
      const { userId } = filter;
      if (userId !== undefined && userId !== null && !Number.isNaN(userId)) {
        queryString += `AND [Zendesk.UserId] = ${userId} `;
      }
    } else {
      queryString += `AND [Zendesk.OrganizationId] = ${filter.organizationId} `;
    }
  }
  queryString += 'ORDER BY [System.Id] desc';
  return queryString;
}
